// extracted by mini-css-extract-plugin
export default {"header":"SingleLesson_header__KRuKd","closeButton":"SingleLesson_closeButton__OU3DP"};